export const resources = {
  Metadata: '',
  FileInformationMetadataDescription: '',
  Description: ''
};
